import '../styles/app.scss';
import './_images';
import './_fonts';
import './formalTeamCampaignHeroLayout';
import DefaultHeader from "./components/DefaultHeader"
import {SignUp} from "./components/SignUp";
document.addEventListener(
	'DOMContentLoaded',
	() => {
		new DefaultHeader();
		new SignUp();
	},
	false
);
